import React, {useEffect, useState} from 'react';
import {useAuth} from '../contexts/AuthContext';
import {toolsApi} from './ResearcherTools';
import './ResearcherTools.css';

type Event = {event_id:string; source:string; occurred_at:string; actor_id:number; actor_role?:string; action:string; reference:string; details?:string};
export default function SystemLogs() {
  const {account} = useAuth();
  const allowed = (account as any)?.userType === 'ADMIN_CYBER';
  const [q,setQ] = useState(''), [source,setSource] = useState('');
  const [page,setPage] = useState(0), [refresh,setRefresh] = useState(0);
  const [items,setItems] = useState<Event[]>([]), [total,setTotal] = useState(0);
  const [loading,setLoading] = useState(false), [error,setError] = useState('');
  useEffect(() => {
    if (!allowed) return;
    let live = true;
    setLoading(true); setError(''); setItems([]);
    const timer = setTimeout(() => {
      toolsApi('/system-logs?' + new URLSearchParams({q,source,page:String(page),size:'50'}))
        .then(data => {if(live){setItems(data.items);setTotal(data.total);}})
        .catch(e => {if(live)setError(e.message);})
        .finally(() => {if(live)setLoading(false);});
    },250);
    return () => {live=false;clearTimeout(timer);};
  },[allowed,q,source,page,refresh]);
  if (!allowed) return <main className="research-tools"><h1>System logs</h1><p role="alert">System administrator access is required.</p></main>;
  return <main className="research-tools">
    <h1>System logs</h1>
    <p>Recorded application, review, workflow configuration and platform activity. Server console output and events that were never recorded are not included.</p>
    <div className="tools-grid">
      <label>Search action, reference, actor ID or details<input value={q} maxLength={200} onChange={e=>{setQ(e.target.value);setPage(0);}}/></label>
      <label>Source<select value={source} onChange={e=>{setSource(e.target.value);setPage(0);}}><option value="">All sources</option><option value="APPLICATION">Applications and reviews</option><option value="PLATFORM">Platform and workflow</option></select></label>
    </div>
    <button onClick={()=>setRefresh(n=>n+1)} disabled={loading}>Refresh</button>
    {error && <p role="alert">{error}</p>}
    {loading ? <p role="status">Loading logs…</p> : !error && <>
      <p>{total} matching events · Page {page+1}</p>
      {!items.length && <p>No recorded events match these filters.</p>}
      <div style={{overflowX:'auto'}}><table style={{width:'100%',textAlign:'left'}}><thead><tr>{['Time','Source','Actor','Action','Reference','Details'].map(t=><th key={t} scope="col">{t}</th>)}</tr></thead>
        <tbody>{items.map(e=><tr key={e.event_id}><td>{new Date(e.occurred_at).toLocaleString()}</td><td>{e.source}</td><td>#{e.actor_id}<br/>{e.actor_role?.replace(/_/g,' ')}</td><td>{e.action.replace(/_/g,' ')}</td><td>{e.reference}</td><td style={{whiteSpace:'pre-wrap',minWidth:220}}>{e.details || '—'}</td></tr>)}</tbody>
      </table></div>
      <button disabled={page===0} onClick={()=>setPage(n=>n-1)}>Previous</button>{' '}
      <button disabled={(page+1)*50>=total} onClick={()=>setPage(n=>n+1)}>Next</button>
    </>}
  </main>;
}
